import { createUseStyles } from 'react-jss'

export const style = {
  buttonGroup: {
    display: 'flex'
  },
  firstButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  insideButton: {
    marginLeft: '1px'
  },
  lastButton: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginLeft: '1px'
  }
}

export const useStyles = createUseStyles(style)
